import {
    ZD_DELIVERY_ISSUES_LIST_SECTION,
    ZD_ITEM_ISSUES_LIST_SECTION,
    ZD_ACTIVE_ORDERS_SECTION_ID,
    ZD_PAST_ORDERS_IWAO_SECTION_ID,
    ZD_PAST_ORDERS_IWDP_SECTION_ID,
} from 'network/api/networkSettings'

const zdDeliveryIssuesListSection = ZD_DELIVERY_ISSUES_LIST_SECTION()
const zdItemsIssuesListSection = ZD_ITEM_ISSUES_LIST_SECTION()
const zdActiveOrdersSectionID = ZD_ACTIVE_ORDERS_SECTION_ID()
const zdPastOrdersIWAOSectionID = ZD_PAST_ORDERS_IWAO_SECTION_ID()
const zdPastOrdersIWDPSectionID = ZD_PAST_ORDERS_IWDP_SECTION_ID()

export const getArticlesUrl = `/guide/help_center/articles`
export const getActiveOrderArticlesUrl = `/guide/help_center/sections/${zdActiveOrdersSectionID}/articles`
export const getPastOrderIWAOArticlesUrl = `/guide/help_center/sections/${zdPastOrdersIWAOSectionID}/articles`
export const getPastOrderIWDPArticlesUrl = `/guide/help_center/sections/${zdPastOrdersIWDPSectionID}/articles`
export const getIssueWithOrderArticlesUrl = `/guide/help_center/articles?label_names=placing_orders&sort_order=desc`
export const getCategoriesUrl = `/guide/help_center/categories`
export const getSectionsUrl = `/guide/help_center/sections`
export const getDeliveryIssuesListUrl = `/guide/help_center/sections/${zdDeliveryIssuesListSection}/articles`
export const getItemsIssuesListUrl = `/guide/help_center/sections/${zdItemsIssuesListSection}/articles`
export const createIssueTicketUrl = `/customers/customers/sendIssueTicket`
export const getTicketsByIdUrl = `/customers/customers/getHelpcenterTickets`
export const VoteForServiceUrl = `/customers/article/vote`
export const getVotesUrl = `/customers/article`
